import axios from "axios";
import getAuthHeader from "./getAuthHeader";

const API_URL = window.config.apiServiceUrl;
const apiClient = axios.create({
  baseURL: API_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    return {
      ...config,
      headers: {
        ...getAuthHeader(),
        "Content-Type": "application/json",
      },
    };
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // Messaging/API downtime or 401 must NOT reload the page / logout.
    // Previously window.location.reload() on 401 caused logout-on-every-refresh
    // when local api (:3003) was unreachable.
    return Promise.reject(error);
  }
);

const { get, post, put, patch, delete: destroy } = apiClient;
export { get, post, put, patch, destroy };
